
/**
 * Encapsulate the logic for creating a focus trap.
 * 
 * `shouldTrap` is a callback function which checks whether the trap should be applied
 */
export function focusTrap(firstRef: React.RefObject<HTMLElement>, lastRef: React.RefObject<HTMLElement>, shouldTrap: () => boolean) {
    return (e: React.KeyboardEvent) => {
        if (shouldTrap()) {
            const keyCode = e.keyCode || e.which;
            if (keyCode === 9) {
                if (e.shiftKey && e.target === firstRef.current) {
                    e.preventDefault();
                    lastRef.current.focus();
                } else if (!e.shiftKey && e.target === lastRef.current) {
                    e.preventDefault();
                    firstRef.current.focus();
                }
            }
        }
    }
}